<div class="subscription">
  <div *ngIf="company.billing as billing" class="subscription__header">
    <div class="subscription-plan">
      <div class="subscription-plan__icon">
        <ng-container [ngSwitch]="billing.status">
          <img *ngSwitchCase="BILLING_STATUS.PAST_DUE" alt="" src="./assets/images/red_flag.png" />
          <img *ngSwitchCase="BILLING_STATUS.SUSPENDED" alt="" src="./assets/images/warning.png" />
          <img *ngSwitchCase="BILLING_STATUS.UNSUBSCRIBED" alt="" src="./assets/images/warning.png" />
          <img *ngSwitchDefault alt="" src="./assets/images/sparkles.png" />
        </ng-container>
      </div>
      <div class="subscription-plan__title">
        <ng-container *ngIf="currentSubscription$ | async as currentSubscription; else statusName">
          <span *ngIf="!shouldDisplayStatusName(currentSubscription); else statusName"
                class="subscription-plan__name">{{ 'subscription.plan.' + currentSubscription.plan.name + '.name' | translate | titlecase }}</span>
        </ng-container>
        <ng-template #statusName>
          <span
            class="subscription-plan__name">{{ 'subscription.plan.' + billing.status + '.name' | translate | titlecase }}</span>
        </ng-template>
        <app-subscription-countdown *ngIf="shouldDisplayTimer()" [billingInfo]="billing"
                                    class="subscription-plan__timer" />
      </div>
      <div *ngIf="currentSubscription$ | async as currentSubscription" class="subscription-plan__status">
        <ng-container [ngSwitch]="billing.status">
          <app-status-label
            *ngSwitchCase="BILLING_STATUS.PAST_DUE"
            [label]="{
            name: 'subscription.plan.PAST_DUE.name' | translate | titlecase,
            color: companyService.getLabelColorDataById('YELLOW')!
          }" />
          <app-status-label
            *ngSwitchCase="BILLING_STATUS.SUSPENDED"
            [label]="{
            name: 'subscription.plan.SUSPENDED.name' | translate | titlecase,
            color: companyService.getLabelColorDataById('RED')!
          }" />
          <app-status-label
            *ngSwitchCase="BILLING_STATUS.FREE"
            [label]="{
            name: 'subscription.plan.FREE.name' | translate | titlecase,
            color: companyService.getLabelColorDataById('GREEN')!
          }" />
          <app-status-label
            *ngSwitchCase="BILLING_STATUS.EARLY_ACCESS"
            [label]="{
            name: 'subscription.plan.EARLY_ACCESS.name' | translate | titlecase,
            color: companyService.getLabelColorDataById('GREEN')!
          }" />
          <app-status-label
            *ngSwitchCase="BILLING_STATUS.SMALL"
            [label]="{
            name: 'Active',
            color: companyService.getLabelColorDataById('GREEN')!
          }" />
          <app-status-label
            *ngSwitchCase="BILLING_STATUS.MEDIUM"
            [label]="{
            name: 'Active',
            color: companyService.getLabelColorDataById('GREEN')!
          }" />
        </ng-container>
      </div>
      <div *ngIf="shouldDisplayWarning()" class="subscription-plan__alert">
        <div class="divider"></div>
        <div class="alert-message">
          <span class="icon-Info"></span>
          <span class="alert-message__content" [innerHTML]="warningMessage$ | async"></span>
        </div>
      </div>
    </div>
    <div class="subscription-action">
      <div class="subscription-action__cta">
        <ng-container [ngSwitch]="billing.status">
          <button (click)="selectPlan()" *ngSwitchCase="BILLING_STATUS.FREE_TRIAL"
                  class="btn-main btn-secondary-purple btn-xs">
            {{ 'subscription.plan_action.select_plan' | translate }}
          </button>

          <button (click)="selectPlan()" *ngSwitchCase="BILLING_STATUS.SUSPENDED"
                  class="btn-main btn-secondary-purple btn-xs">
            {{ 'subscription.plan_action.subscribe' | translate }}
          </button>

          <button (click)="selectPlan()" *ngSwitchCase="BILLING_STATUS.UNSUBSCRIBED"
                  class="btn-main btn-secondary-purple btn-xs">
            {{ 'subscription.plan_action.select_plan' | translate }}
          </button>
        </ng-container>
      </div>

      <div *ngIf="shouldDisplayActionMenu()">
        <span class="icon icon-Dots-2 icon-hover" [matMenuTriggerFor]="menu"></span>
        <mat-menu #menu="matMenu" class="general-menu">
          <button (click)="cancelSubscription()" mat-menu-item>
            <span class="icon icon-Close"></span>
            <span class="name">{{ 'actions.cancel_subscription' | translate }}</span>
          </button>
        </mat-menu>
      </div>
    </div>
  </div>
  <app-subscription-stats
    *ngIf="company.billing?.status !== BILLING_STATUS.UNSUBSCRIBED"
    [currentSubscription]="currentSubscription$ | async"
    [company]="company" />
</div>
